import $ from 'jquery';
import slick from 'slick-carousel';

/* Global variables
********************************************/

var $breakpointSM = 480;
var $breakpointMD = 769;
var $breakpointLG = 992;

const thickArrowSvg = window.emagazine_script.thick_arrow_svg;
const thinArrowSvg = window.emagazine_script.thin_arrow_svg;

/* Sliders
********************************************/

$( function() {
	if ( $( '.js-series-slider' ).length ) {
		const settings = {
			mobileFirst: true,
			infinite: false,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: `<a href="" class="c-slider__arrow c-slider__arrow--next">${thickArrowSvg}${thinArrowSvg}</a>`,
			prevArrow: `<a href="" class="c-slider__arrow c-slider__arrow--prev">${thickArrowSvg}${thinArrowSvg}</a>`,
			responsive: [
				{
					breakpoint: $breakpointMD - 1,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				}
			]
		};

		$( '.js-series-slider' ).slick( settings );
	}
	if ( $( '.js-series-slider--down-md' ).length ) {
		const settings = {
			mobileFirst: true,
			infinite: false,
			autoplay: false,
			adaptiveHeight: false,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: `<a href="" class="c-slider__arrow c-slider__arrow--next">${thickArrowSvg}${thinArrowSvg}</a>`,
			prevArrow: `<a href="" class="c-slider__arrow c-slider__arrow--prev">${thickArrowSvg}${thinArrowSvg}</a>`,
			responsive: [
				{
					breakpoint: $breakpointMD - 1,
					settings: "unslick"
				}
			]
		};

		$( '.js-series-slider--down-md' ).slick( settings );
	}
} );



if ($('.js-gallery-slider').length) {
	$('.js-gallery-slider').slick({
		mobileFirst: false,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		draggable: true,
		swipe: true,
		fade: false,
		variableWidth: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		dotsClass: 'c-slider__dots',
		arrows: true,
		nextArrow: `<a href="" class="c-slider__arrow c-slider__arrow--large@xl c-slider__arrow--next">${thickArrowSvg}${thinArrowSvg}</a>`,
		prevArrow: `<a href="" class="c-slider__arrow c-slider__arrow--large@xl c-slider__arrow--prev">${thickArrowSvg}${thinArrowSvg}</a>`,
		//appendArrows: '.slick-list',
	});
}
